import { render, staticRenderFns } from "./configModal.vue?vue&type=template&id=529a0e90&scoped=true"
import script from "./configModal.vue?vue&type=script&lang=js"
export * from "./configModal.vue?vue&type=script&lang=js"
import style0 from "./configModal.vue?vue&type=style&index=0&id=529a0e90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529a0e90",
  null
  
)

export default component.exports